module.exports = __webpack_public_path__ + "img/6ca7f5e.webp";